import React, { useContext, useEffect } from "react";
import styles from "./MoreServices.module.scss";
import { Context } from "../../Store";
import Slider from "./Slider";
import vector3 from "../../../imgs/vector3.png";
import vector4 from "../../../imgs/vector4.png";
import Loading from "../../Loading/Loading";
const MoreServices = () => {
  const {
    dir,
    setIsClicked,
    // packagesSection,
    services2ResData,
    servicesRes2Loading,
  } = useContext(Context);
  const { title, subTitle } = services2ResData;
  useEffect(() => {
    setIsClicked(false);
  }, [setIsClicked]);
  return (
    <>
      <section
        id={styles.moreServices}
        //  ref={packagesSection}
      >
        <img
          src={vector3}
          className={dir === "ltr" ? styles.vector3L : styles.vector3R}
          alt=""
        />
        <img
          src={vector4}
          className={dir === "ltr" ? styles.vector4L : styles.vector4R}
          alt=""
        />
        <div className={styles.container}>
          {servicesRes2Loading ? (
            <Loading />
          ) : (
            <>
              <div className={styles.item0}>
                <h2>{title}</h2>
                <p>{subTitle}</p>
              </div>
              <div className={styles.items1}>
                <Slider />
              </div>
            </>
          )}
        </div>
      </section>
    </>
  );
};

export default MoreServices;
